const UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];
const STORAGE_KEY = 'aiweon_utm';

export function captureUTMParams() {
  const params = new URLSearchParams(window.location.search);
  const utm = {};
  let hasUTM = false;

  UTM_KEYS.forEach(key => {
    const value = params.get(key);
    if (value) {
      utm[key] = value;
      hasUTM = true;
    }
  });

  if (hasUTM) {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(utm));
  }
}

export function getStoredUTM() {
  try {
    const stored = sessionStorage.getItem(STORAGE_KEY);
    return stored ? JSON.parse(stored) : {};
  } catch {
    return {};
  }
}
